import { useCallback, useEffect, useState } from "react";
import useApi from "../Api/Api";

const useEventComparison = () => {
  const api = useApi();
  const [events, setEvents] = useState([]);
  const [pagy, setPagy] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortFilter, setSortFilter] = useState("date");
  const [searchFilter, setSearchFilter] = useState();
  const [attendanceMin, setAttendanceMin] = useState();
  const [attendanceMax, setAttendanceMax] = useState();
  const [grossMin, setGrossMin] = useState();
  const [grossMax, setGrossMax] = useState();

  const getEvents = useCallback(
    (page) => {
      let queryParams = { page };
      if (sortFilter) {
        queryParams.sort = sortFilter;
      }
      if (searchFilter) {
        queryParams.query = searchFilter;
      }
      if (attendanceMin != null) {
        queryParams.attendance_min = attendanceMin;
      }
      if (attendanceMax != null) {
        queryParams.attendance_max = attendanceMax;
      }
      if (grossMin != null) {
        queryParams.gross_min = grossMin;
      }
      if (grossMax != null) {
        queryParams.gross_max = grossMax;
      }
      const queryString = Object.keys(queryParams)
        .map((param) => `${param}=${queryParams[param]}`)
        .join("&");
      // page + sort are always present; any additional key means an active filter
      const hasActiveFilter = Object.keys(queryParams).length > 2;
      if (hasActiveFilter) {
        api.get(`/events/comparison?${queryString}`).then((r) => {
          setEvents(r.data.data);
          setPagy(r.data.pagy);
        });
      }
    },
    [api, searchFilter, sortFilter, attendanceMin, attendanceMax, grossMin, grossMax]
  );

  useEffect(() => {
    setPagy([]);
    setEvents([]);
  }, []);

  useEffect(() => {
    getEvents(currentPage);
  }, [getEvents, currentPage]);

  const resetPagination = () => {
    setEvents([]);
    setPagy([]);
    setCurrentPage(1);
  };

  events.forEach((event) => {
    const [year, month, day] = event.date.split("T")[0].split("-");
    event.formattedDate = `${month}/${day}/${year}`;
  });

  return {
    events,
    pagy,
    setCurrentPage,
    sortFilter,
    setSortFilter,
    resetPagination,
    setSearchFilter,
    setAttendanceMin,
    setAttendanceMax,
    setGrossMin,
    setGrossMax,
  };
};

export default useEventComparison;
